var map = {
	"./Cnesst/init.ts": 4443,
	"./DigitalHealthDrugRepository/init.ts": 65949,
	"./InstantMessaging/init.ts": 8430,
	"./Oacis/init.ts": 37323,
	"./Olis/init.ts": 16777,
	"./OntarioMdHealthReportManager/init.ts": 35659
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 530;